import React, { useState } from "react";
import { ChevronRight } from "lucide-react";

const Section = ({ title, children, defaultOpen = true }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div style={{borderBottom:"1px solid var(--mv-border)",paddingBottom:14,marginBottom:14}}>
      <div onClick={()=>setOpen(!open)} style={{cursor:"pointer",display:"flex",alignItems:"center",gap:8,fontWeight:700,fontSize:14,color:"var(--mv-text)",marginBottom:open?12:0}}>
        <ChevronRight size={16} style={{transform: open ? "rotate(90deg)" : "rotate(0)", transition: "transform .15s"}} />
        {title}
      </div>
      {open && children}
    </div>
  );
};
export default Section;
